const config = {
    NATIVE: process.env.REACT_APP_NATIVE == 'true'?true:false,
    MAPSKEY: process.env.REACT_APP_NATIVE == 'true'?process.env.REACT_APP_NATIVEMAPSKEY:'AIzaSyC9fQKMrbwFebmYcgah_MCqgGKlIpk8pjk'
};
  
export default {
    ...config
};